import { Controller } from "@hotwired/stimulus"

// Toggle threshold field when cost alerts are disabled on the technical sheet form
export default class extends Controller {
  static targets = ["enabled", "threshold"]

  connect() {
    this.syncThresholdDisabled()
  }

  syncThresholdDisabled() {
    if (!this.hasEnabledTarget || !this.hasThresholdTarget) return
    this.thresholdTarget.disabled = !this.enabledTarget.checked
  }

  clearThreshold(event) {
    event.preventDefault()
    this.thresholdTarget.value = ""
  }
}
